<template>
  <a @click="logout">
    <slot></slot>
  </a>
</template>

<script>
import inIframe from "@/helpers/inIframe";
import {mapActions} from "vuex";

export default {
  methods: {
    ...mapActions({
      //getLib: 'GET_LIB',
      LOGOUT: 'LOGOUT',
      getProfile: 'GET_PROFILE',

    }),
    logout() {
      this.LOGOUT().then(res => {
        if (res.data.status == "ok") {
          this.$store.state.access_token = '';
          this.$store.state.profile = {};
          if (!inIframe()) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('authToken');
          }
          this.getProfile();
          //this.getLib(true)
          this.$router.push("/");
        }
      });
    }
  }
};
</script>
